<template>
  <div class="mb-3 rounded-5" :class="[`${group.color}-feed-background`]">
    <div
      class="card rounded-5 card-body bg-light shadow-sm text-dark px-4 pt-4"
      :class="[`${group.color}-feed-inner`]"
    >
      <div class="row align-items-center mb-3">
        <div class="col-4 text-start d-flex align-items-center">
          <div class="me-2 d-none d-md-block">
            <!-- ICON HERE -->
            <GroupIcon :index="group.index" :width="size" />
          </div>
          <div class="fs-4 fw-bold my-auto">{{ name }}</div>
        </div>
        <div class="col text-start fw-bold fs-5">
          {{ reason }}
        </div>
        <div class="col fw-bold fs-3 d-flex justify-content-center">
          <StarIcon :points="points" />
        </div>
      </div>
      <div class="text-end">
        {{ formatDate(tsLastUpdated) }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { shortenName, formatDate } from "@/helpers/common.js";
import GroupIcon from "@/components/activity/GroupIcon.vue";
import StarIcon from "@/components/activity/StarIcon.vue";
// Data
export default {
  name: "GroupFeedCard",
  components: { GroupIcon, StarIcon },
  props: {
    name: {
      type: String,
      required: true
    },
    points: {
      type: Number,
      required: true
    },
    reason: {
      type: String,
      required: false,
      default: ""
    },
    tsLastUpdated: {
      type: String,
      required: true
    },
    size: {
      type: [Number, String],
      default: 65
    }
  },
  computed: {
    ...mapGetters("groups", ["getGroups"]),
    group() {
      let groups = this.getGroups;
      let group = groups.find(
        (g) => g.name.toLowerCase() === this.name.toLowerCase()
      );
      return group;
    }
  },
  methods: {
    shortenName,
    formatDate
  }
};
</script>
